import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, Music } from 'lucide-react';
import './Navbar.css';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/events', label: 'Events & Parties' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact Us' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <img src="/Assets/logo.png" alt="Jimmy'z Band Logo" className="logo-img" />
          </Link>

          <ul className="navbar-links">
            {navLinks.map(l => (
              <li key={l.to}>
                <Link to={l.to} className={`nav-link ${location.pathname === l.to ? 'active' : ''}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>

          <a href="tel:+919414203966" className="navbar-phone">
            <Phone size={14} />
            <span>+91 9414203966</span>
          </a>

          <button className="hamburger" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${open ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <div className="logo-text">
            <img src="/Assets/logo.png" alt="Jimmy'z Band Logo" className="logo-img-mobile" />
          </div>
          <button onClick={() => setOpen(false)}><X size={24} /></button>
        </div>
        <ul className="mobile-links">
          {navLinks.map((l, i) => (
            <li key={l.to} style={{ animationDelay: `${i * 0.06}s` }}>
              <Link to={l.to} className={location.pathname === l.to ? 'active' : ''}>{l.label}</Link>
            </li>
          ))}
        </ul>
        <a href="tel:+919414203966" className="mobile-phone">
          <Phone size={16} /> +91 9414203966
        </a>
      </div>
      {open && <div className="overlay" onClick={() => setOpen(false)} />}
    </>
  );
}
